export default __webpack_public_path__ + "static/media/640_private01-it-mobile.077aa8c0.png";